export default __webpack_public_path__ + "static/media/Amy.5ec7231b.png";